import {
  Component,
  EventEmitter,
  OnInit,
  Output,
} from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Subject, takeUntil } from 'rxjs';
import { NzMessageService } from 'ng-zorro-antd/message';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { BaseService } from 'src/app/services/base.service';
import { LIST_IP_ADDRESS } from 'src/app/constants/endpoint.const';
import { FormValidationService } from 'src/app/services/form-validation.service';

@Component({
  standalone: false,
  selector: 'app-modal-add-referrer',
  templateUrl: './modal-add-referrer.component.html',
  styleUrls: ['./modal-add-referrer.component.scss'],
})
export class ModalAddReferrerComponent implements OnInit {
  destroy$ = new Subject();
  formGroupReferrer: FormGroup = new FormGroup({
    ipAddress: new FormControl('', [
      Validators.required,
      Validators.minLength(5),
    ]),
    platform: new FormControl('', [
      Validators.required,
      Validators.minLength(5),
    ]),
  });
  isValid: boolean = true;
  isValidPlatform: boolean = true;
  errIP: string = '';
  errPN: string = '';
  @Output() addRef = new EventEmitter();

  constructor(
    private activeModal: NgbActiveModal,
    private message: NzMessageService,
    private baseService: BaseService,
    private validationService: FormValidationService
  ) {}
  ngOnInit(): void {}

  close() {
    this.activeModal.close();
  }

  setRegexIP(event: KeyboardEvent) {
    return this.validationService.allowOnlyAlphaNumericSpecial(event);
  }

  setValueRule() {
    const value = this.formGroupReferrer.get('ipAddress')?.value || '';
    const result = this.validationService.validateIPAddress(value);
    this.isValid = result.valid;
    this.errIP = result.message;
  }

  setValueRulePlatform() {
    const value = this.formGroupReferrer.get('platform')?.value || '';
    const result = this.validationService.validateUrl(value);
    this.isValidPlatform = result.valid;
    this.errPN = result.message;
  }

  submit() {
    const params = {
      ip_address: this.formGroupReferrer.get('ipAddress')?.value,
      platform_name: this.formGroupReferrer.get('platform')?.value,
    };
    this.baseService
      .postData(LIST_IP_ADDRESS, params)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (res) => {
          this.message.create(
            'success',
            'Your referrer has been successfully added.'
          );
          this.activeModal.close();
          this.addRef.emit();
        },
        (err) => {
          this.message.create('error', err.error.meta.message);
        }
      );
  }
}
